export const SHOW_SHOP_DEPARTMENT = 'SHOW_SHOP_DEPARTMENT';
export const HIDE_SHOP_DEPARTMENT = 'HIDE_SHOP_DEPARTMENT';
